module.exports = __webpack_public_path__ + "img/icon_eos.2cdabc8f.svg";